//API constants for store
export const storesConstants = {
  BRAND: "brand",
  BRAND_ID: "BRAND_ID",
  RESET_STORE: "RESET_STORE",
  FETCH_STORE: "FETCH_STORE",
  SINGLE_STORE: "SINGLE_STORE",
  FILTER_STORES: "FILTER_STORES",
  FETCH_ALL_STORE: "FETCH_ALL_STORE",
  UPDATE_GROUP: "UPDATE_GROUP_STATUS",
  FETCH_ALL_BRANDS: "FETCH_ALL_BRANDS",
  FETCH_STORE_BY_ID: "FETCH_STORE_BY_ID",
  FETCH_STORE_DETAILS: "FETCH_STORE_DETAILS",
  FETCH_BRAND_LOCATIONS: "FETCH_BRAND_LOCATIONS",
  FETCH_ALL_STORE_BY_BRAND_ID: "FETCH_ALL_STORE_BY_BRAND_ID",
  GET_ALL_BRANDS_FOR_FILTER_DROPDOWN: "GET_ALL_BRANDS_FOR_FILTER_DROPDOWN",
};

//Data for stores filter
export const brandFilterDropDown = [
  {
    value: "brand",
    name: "Brand",
  },
  {
    value: "store",
    name: "Store",
  },
];

export const responseType = {
  POSITIVE: 1,
  NEGATIVE: 2,
};

export const STORES_BRAND_ID_RESTORE_TIMEOUT_MS = 200;

export const STORES_LABELS = {
  SEARCH: "Search",
  BRANDS: "Brands",
  BRAND_HEADER: "BRAND",
  STATUS_HEADER: "STATUS",
  NO_STORE_FOUND: "No Store Found",
  NO_BRAND_FOUND: "No Brand Found",
};
